<script lang="ts">
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let caption: string = '';
  export let variant: 'styled' | 'normal' = 'normal';
  export let accentClass: string = '';
</script>

{#if variant === 'styled'}
  {#if dangerMessage || caption}
    <caption
      class="{danger && dangerMessage ? 'text-accent-red-40' : 'text-garden-grey-500'}
      text-xs whitespace-pre text-left {accentClass}"
    >
      {#if danger && dangerMessage}
        {dangerMessage || ''}
      {:else if caption}{caption || ''}{/if}
    </caption>
  {/if}
{:else if danger}
  <caption class="text-accent-red-40 text-xs {accentClass}">
    {#if dangerMessage}{dangerMessage}{:else}&nbsp;{/if}
  </caption>
{:else}
  <caption class="text-garden-grey-500 text-xs {accentClass}">
    {#if caption}{caption}{:else}&nbsp;{/if}
  </caption>
{/if}
